/*

? First, let's import the interface that will describe the shape of our chat object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the chat object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const broadcast_data: StateInterface["broadcast_data"] = {
    commission_offered: 0,
    no_of_agents: 0,
    notes: '',
    open_to_negotiation: false,
};
